/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * Contact: redjar.redelivery@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type EnumsBusinessType = 1 | 2;

export const EnumsBusinessType = {
    NUMBER_1: 1 as EnumsBusinessType,
    NUMBER_2: 2 as EnumsBusinessType
};